const NamePatterns = {
  Default: /^[a-zA-Z\-]+([\'|\-|\ ]{1}[a-zA-Z\-]+){1,2}$/,
  FullName: /^([a-zA-Z\-\']+) ([a-zA-Z\-\']+) ([a-zA-Z\-\']+)$/,
};

export class RegexPattern {
  public static readonly Name = Object.freeze(NamePatterns);
}
